import { Component } from "react";
import { ToastContainer } from "react-toastify";
import LayoutWrapper from "../LayoutWrapper";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Slider from "react-slick";

export class AllContentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      tabkey: "topics",
      data: {},
    };
    this.sliderSettings = {
      dots: true,
      infinite: true,
      lazyLoad: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 2000,
      autoplaySpeed: 2000,
    };
  }

  componentDidMount() {
    this.getProductDetails();
  }

  getProductDetails() {
    this.setState({
      loader: true,
    });
    let payload = {
      package_id: this.props.urlparams.packageId,
    };
    console.log({ payload });

    this.props.api
      .apiGetProductById(payload)
      .then(({ data }) => {
        console.log({ data });

        this.setState({
          data,
          loader: false,
        });
      })
      .catch((err) => {
        this.setState({
          loader: false,
        });
      });
  }
  handleNameChange(e) {
    console.log(e.target.value);
  }

  handleTab(key) {
    this.setState({ tabkey: key });
  }

  getBreadcrumbs() {
    return `Home / Buy Content / ${this.props.urlparams.packageName || "..."}`;
  }

  render() {
    let { navigate } = this.props;
    let { loader, tabkey } = this.state;
    let {
      package_name,
      recommendedClassDetails,
      package_description,
      thumbnail_file,
      e_comm_configuration,
      media_configuration,
      sessionDetails,
    } = this.state?.data;
    return (
      <>
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <LayoutWrapper
          title={`Hello ${window.store.getState().root?.user?.full_name}`}
          back={this.getBreadcrumbs()}
          backlink="/allcontent"
        >
          <ToastContainer position="top-right" />
          <div class="container-fluid content_details_container py-4">
            <div class="row mb-5">
              <div class="col-lg-6">
                <Slider {...this.sliderSettings}>
                  {media_configuration &&
                    media_configuration?.media_images?.map((obj) => {
                      let { url } = obj;
                      return (
                        <div>
                          <img src={url} alt="slider image" />
                        </div>
                      );
                    })}
                  {media_configuration &&
                    media_configuration?.media_videos?.map((link, i) => {
                      return (
                        <>
                          <div
                            style={{
                              padding: "53.75% 0 0 0",
                              position: "relative",
                            }}
                          >
                            <iframe
                              src={link}
                              frameborder="0"
                              allow="autoplay; fullscreen; picture-in-picture"
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                              }}
                              title="videos"
                            ></iframe>
                          </div>
                        </>
                      );
                    })}
                </Slider>
              </div>
              <div class="col-lg-6">
                <div class="content">
                  <h2 class="title">{package_name}</h2>
                  <p class="m-0">Applicable Grades</p>
                  <div class="qty mb-4">
                    <span class="title">
                      {recommendedClassDetails?.map((grade, i) => {
                        let { curriculum_grade } = grade;
                        return `Grade ${curriculum_grade}${
                          i === recommendedClassDetails.length - 1 ? "" : ","
                        }`;
                      })}
                    </span>
                  </div>
                  <hr />
                  <h4 class="subtitle">Description</h4>
                  <p>{package_description}</p>
                  {this.props.urlparams.accessed === "true" && (
                    <button
                      class="btn btn-success btn-block"
                      onClick={(...args) =>
                        navigate(
                          `/mycontent/sessions?packageId=${this.props.urlparams.packageId}&packageName=${this.props.urlparams.packageName}`
                        )
                      }
                    >
                      Go to Content
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="content_details_tab_container">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={tabkey}
                    onSelect={(k) => this.handleTab(k)}
                    className="mb-3"
                  >
                    <Tab eventKey="topics" title="Topics covered">
                      <ul class="topics_covered_container">
                        {sessionDetails &&
                          sessionDetails?.map(
                            ({ session_name, session_description }, i) => {
                              return (
                                <li>
                                  <span>
                                    {i + 1}. {session_name}
                                  </span>
                                  <span>{session_description}</span>
                                </li>
                              );
                            }
                          )}
                      </ul>
                    </Tab>
                    <Tab eventKey="availability" title="Buy Now">
                      <table class="table availability_table">
                        <thead>
                          <th>Sold By</th>
                        </thead>
                        <tbody>
                          {e_comm_configuration &&
                            e_comm_configuration?.map((row) => {
                              let { platform_name, product_url } = row;
                              return (
                                <tr>
                                  <td>{platform_name}</td>
                                  <td>
                                    <a
                                      href={product_url}
                                      target="_blank"
                                      className="btn btn-success btn-block"
                                      disabled={
                                        product_url === undefined ? true : false
                                      }
                                    >
                                      <span>
                                        {product_url
                                          ? "Visit Site"
                                          : "Comming Soon"}
                                      </span>
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </LayoutWrapper>
      </>
    );
  }
}

export default connect(AllContentDetails);
